// @ts-strict-ignore
import React from 'react'
import { ButtonLink } from '../button-link-element'
import { gtmTrack } from '../../utils/tracking'
import { timeout, useComponentTracking } from '../../utils/component-events'

const ButtonWrapper = (props) => {
  const { children, href } = props
  const trackComponent = useComponentTracking()

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    gtmTrack('GA Button Clicked', 'Functional Interaction', `${children}`)
    timeout(
      trackComponent('Dynamic Component Event', 'CTAButtonClicked', { text: `${children}` }),
    ).then(() => {
      if (props.target) {
        window.open(href)
      } else {
        window.location.href = href
      }
    })
  }

  return (
    <ButtonLink {...props} onClick={(e: React.MouseEvent) => onClick(e)}>
      {children}
    </ButtonLink>
  )
}

export default ButtonWrapper
